module.exports = __webpack_public_path__ + "static/img/24.9b04fe6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/24.png
// module id = 9jQ9
// module chunks = 1